const state = {
  quoteId: null,
  parentQuoteId: null,
  juridicalPersonObj: {
    cnpj: null,
    legalName: null,
    city: null,
    nameContact: null,
    phoneContact: null,
    emailContact: null,
    emailWithCopy: null,
  },
  juridicalPersonKitObj: {
    cnpj: null,
    legalName: null,
    effectiveDate: null,
    address: null,
    addressZip: null,
    addressNeighborhood: null,
    addressNumber: null,
    addressComplement: null,
    addressCity: null,
    addressState: null,
  },
  planFiltersObj: {
    allEmployees: [],
    hasCopay: [],
    accommodations: [],
    geographicScopes: [],
    planClassifications: [],
    hospitalsObj: [],
    laboratoriesObj: [],
  },
  ageIntervalsTotalObj: null,
  ageIntervalsObj: [],
  enumeratedAgesObj: [],
  benefitsObj: [],
  plansGroupByBenefitCarrierObj: [],
  projectObj: {
    id: null,
  },
};

const mutations = {
  setAgeIntervalsObj(state, payload) {
    state.ageIntervalsObj = payload;
  },
  setEnumeratedAgesObj(state, payload) {
    state.enumeratedAgesObj = payload;
  },
  setJuricalPersonCNPJ(state, payload) {
    state.juridicalPersonObj.cnpj = payload;
  },
  setJuricalPersonLegalName(state, payload) {
    state.juridicalPersonObj.legalName = payload;
  },
  setJuricalPersonCity(state, payload) {
    state.juridicalPersonObj.city = payload;
  },
  setJuricalPersonName(state, payload) {
    state.juridicalPersonObj.nameContact = payload;
  },
  setJuricalPersonPhone(state, payload) {
    state.juridicalPersonObj.phoneContact = payload;
  },
  setJuricalPersonEmail(state, payload) {
    state.juridicalPersonObj.emailContact = payload;
  },
  setJuricalPersonEmailWithCopy(state, payload) {
    state.juridicalPersonObj.emailWithCopy = payload;
  },
  setContractFilterAllEmployees(state, payload) {
    state.planFiltersObj.allEmployees = Object.assign([], payload);
  },
  setContractFilterHasCopay(state, payload) {
    state.planFiltersObj.hasCopay = Object.assign([], payload);
  },
  setContractFilterAccommodations(state, payload) {
    state.planFiltersObj.accommodations = Object.assign([], payload);
  },
  setContractFilterGeographicScopes(state, payload) {
    state.planFiltersObj.geographicScopes = Object.assign([], payload);
  },
  setContractFilterPlanClassifications(state, payload) {
    state.planFiltersObj.planClassifications = Object.assign([], payload);
  },
  setHospitalsObj(state, payload) {
    state.planFiltersObj.hospitalsObj = payload;
  },
  setLaboratoriesObj(state, payload) {
    state.planFiltersObj.laboratoriesObj = payload;
  },
  setBenefitsObj(state, payload) {
    state.benefitsObj = Object.assign([], payload);
  },
  setAgeIntervalsTotalObj(state, payload) {
    state.ageIntervalsTotalObj = Object.assign({}, payload);
  },
  setPlansGroupByBenefitCarrierObj(state, payload) {
    state.plansGroupByBenefitCarrierObj = Object.assign([], payload);
  },
  setJuricalPersonKitCNPJ(state, payload) {
    state.juridicalPersonKitObj.cnpj = payload;
  },
  setJuricalPersonKitLegalName(state, payload) {
    state.juridicalPersonKitObj.legalName = payload;
  },
  setJuricalPersonKitAddressZip(state, payload) {
    state.juridicalPersonKitObj.addressZip = payload;
  },
  setJuricalPersonKitAddress(state, payload) {
    state.juridicalPersonKitObj.address = payload;
  },
  setJuricalPersonKitAddressNumber(state, payload) {
    state.juridicalPersonKitObj.addressNumber = payload;
  },
  setJuricalPersonKitAddressComplement(state, payload) {
    state.juridicalPersonKitObj.addressComplement = payload;
  },
  setJuricalPersonKitAddressNeighborhood(state, payload) {
    state.juridicalPersonKitObj.addressNeighborhood = payload;
  },
  setJuricalPersonKitAddressState(state, payload) {
    state.juridicalPersonKitObj.addressState = payload;
  },
  setJuricalPersonKitAddressCity(state, payload) {
    state.juridicalPersonKitObj.addressCity = payload;
  },
  setJuricalPersonKitEffectiveDate(state, payload) {
    state.juridicalPersonKitObj.effectiveDate = payload;
  },
  setProjectId(state, payload) {
    state.projectObj.id = payload;
  },
  setParentQuoteId(state, payload) {
    state.parentQuoteId = payload;
  },
  setQuoteId(state, payload) {
    state.quoteId = payload;
  },
};

const actions = {
  setAgeIntervalsObj(context, payload) {
    context.commit('setAgeIntervalsObj', payload);
  },
  setEnumeratedAgesObj(context, payload) {
    context.commit('setEnumeratedAgesObj', payload);
  },
  setJuricalPersonCNPJ(context, payload) {
    context.commit('setJuricalPersonCNPJ', payload);
  },
  setJuricalPersonLegalName(context, payload) {
    context.commit('setJuricalPersonLegalName', payload);
  },
  setJuricalPersonKitEffectiveDate(context, payload) {
    context.commit('setJuricalPersonKitEffectiveDate', payload);
  },
  setJuricalPersonCity(context, payload) {
    context.commit('setJuricalPersonCity', payload);
  },
  setJuricalPersonName(context, payload) {
    context.commit('setJuricalPersonName', payload);
  },
  setJuricalPersonPhone(context, payload) {
    context.commit('setJuricalPersonPhone', payload);
  },
  setJuricalPersonEmail(context, payload) {
    context.commit('setJuricalPersonEmail', payload);
  },
  setJuricalPersonEmailWithCopy(context, payload) {
    context.commit('setJuricalPersonEmailWithCopy', payload);
  },
  setContractFilterAllEmployees(context, payload) {
    context.commit('setContractFilterAllEmployees', payload);
  },
  setContractFilterHasCopay(context, payload) {
    context.commit('setContractFilterHasCopay', payload);
  },
  setContractFilterAccommodations(context, payload) {
    context.commit('setContractFilterAccommodations', payload);
  },
  setContractFilterGeographicScopes(context, payload) {
    context.commit('setContractFilterGeographicScopes', payload);
  },
  setContractFilterPlanClassifications(context, payload) {
    context.commit('setContractFilterPlanClassifications', payload);
  },
  setHospitalsObj(context, payload) {
    context.commit('setHospitalsObj', payload);
  },
  setLaboratoriesObj(context, payload) {
    context.commit('setLaboratoriesObj', payload);
  },
  setBenefitsObj(context, payload) {
    context.commit('setBenefitsObj', payload);
  },
  setAgeIntervalsTotalObj(context, payload) {
    context.commit('setAgeIntervalsTotalObj', payload);
  },
  setPlansGroupByBenefitCarrierObj(context, payload) {
    context.commit('setPlansGroupByBenefitCarrierObj', payload);
  },
  setJuricalPersonKitCNPJ(context, payload) {
    context.commit('setJuricalPersonKitCNPJ', payload);
  },
  setJuricalPersonKitLegalName(context, payload) {
    context.commit('setJuricalPersonKitLegalName', payload);
  },
  setJuricalPersonKitAddressZip(context, payload) {
    context.commit('setJuricalPersonKitAddressZip', payload);
  },
  setJuricalPersonKitAddress(context, payload) {
    context.commit('setJuricalPersonKitAddress', payload);
  },
  setJuricalPersonKitAddressNumber(context, payload) {
    context.commit('setJuricalPersonKitAddressNumber', payload);
  },
  setJuricalPersonKitAddressComplement(context, payload) {
    context.commit('setJuricalPersonKitAddressComplement', payload);
  },
  setJuricalPersonKitAddressNeighborhood(context, payload) {
    context.commit('setJuricalPersonKitAddressNeighborhood', payload);
  },
  setJuricalPersonKitAddressState(context, payload) {
    context.commit('setJuricalPersonKitAddressState', payload);
  },
  setJuricalPersonKitAddressCity(context, payload) {
    context.commit('setJuricalPersonKitAddressCity', payload);
  },
  setProjectId(context, payload) {
    context.commit('setProjectId', payload);
  },
  setParentQuoteId(context, payload) {
    context.commit('setParentQuoteId', payload);
  },
  setQuoteId(context, payload) {
    context.commit('setQuoteId', payload);
  },
};

const getters = {
  quoteId: (state) => state.quoteId,
  parentQuoteId: (state) => state.parentQuoteId,
  ageIntervalsObj: (state) => state.ageIntervalsObj,
  enumeratedAgesObj: (state) => state.enumeratedAgesObj,
  juridicalPersonObj: (state) => state.juridicalPersonObj,
  planFiltersObj: (state) => state.planFiltersObj,
  benefitsObj: (state) => state.benefitsObj,
  ageIntervalsTotalObj: (state) => state.ageIntervalsTotalObj,
  plansGroupByBenefitCarrierObj: (state) => state.plansGroupByBenefitCarrierObj,
  juridicalPersonKitObj: (state) => state.juridicalPersonKitObj,
  projectObj: (state) => state.projectObj,
  quoteDataObj (state) {
    return {
      quoteId: state.quoteId,
      parentQuoteId: state.parentQuoteId,
      ageIntervalsObj: state.ageIntervalsObj,
      enumeratedAgesObj: state.enumeratedAgesObj,
      juridicalPersonObj: state.juridicalPersonObj,
      planFiltersObj: state.planFiltersObj,
      benefitsObj: state.benefitsObj,
      ageIntervalsTotalObj: state.ageIntervalsTotalObj,
      plansGroupByBenefitCarrierObj: state.plansGroupByBenefitCarrierObj,
      juridicalPersonKitObj: state.juridicalPersonKitObj,
      projectObj: state.projectObj
    }
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
